// import http from "../axios/http-common-login";
import http from "../axios/http-common";

class DataLogin {
  async getDataLogin(username, pass) {
    let dt: any;
    await http.postData(`/login`, {
            username: username,
            password: pass
          })
      .then(response => {
        dt = response;
      })
      .catch(e => {
        dt = e.response;
      });
    return dt;
  }
}

export default new DataLogin();
